import React from 'react';
import {
  Box,
  FormControlLabel,
  Typography,
  List,
  ListItem,
  ListItemText,
  Checkbox,
} from '@mui/material';
import { ViewColumnOutlined } from '@mui/icons-material';
import { useModalStyles } from './useModalStyles';

interface ColumnToggleProps {
  columns: { id: string, label: string | JSX.Element }[];
  hiddenColumns: string[];
  setHiddenColumns: (columns: string[]) => void;
}

const ColumnToggle: React.FC<ColumnToggleProps> = ({ columns, hiddenColumns, setHiddenColumns }) => {
  const { tokens: mTokens, isDark } = useModalStyles();

  const handleToggle = (columnId: string) => {
    setHiddenColumns(
      hiddenColumns.includes(columnId)
        ? hiddenColumns.filter(id => id !== columnId)
        : [...hiddenColumns, columnId]
    );
  };

  return (
    <Box sx={{ width: 260, py: 1 }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
          px: 2,
          pb: 1.2,
          mb: 0.5,
          borderBottom: `1px solid ${mTokens.border}`,
        }}
      >
        <ViewColumnOutlined sx={{ fontSize: "1.1rem", color: mTokens.accent }} />
        <Typography sx={{ fontSize: "0.9rem", fontWeight: 800, color: mTokens.textPrimary }}>
          Toggle Columns
        </Typography>
      </Box>
      <List sx={{ py: 0 }}>
        {columns.map((column) => {
          const checked = !hiddenColumns.includes(column.id);
          return (
            <ListItem
              key={column.id}
              sx={{
                px: 1,
                py: 0.2,
                mx: 1,
                width: "auto",
                borderRadius: "8px",
                transition: "background-color 0.15s ease",
                "&:hover": {
                  backgroundColor: isDark ? "rgba(20,184,166,0.08)" : "rgba(20,184,166,0.06)",
                },
              }}
            >
              <FormControlLabel
                sx={{ width: "100%", ml: 0 }}
                control={
                  <Checkbox
                    checked={checked}
                    onChange={() => handleToggle(column.id)}
                    sx={{
                      color: mTokens.textSecondary,
                      "&.Mui-checked": { color: mTokens.accent },
                    }}
                  />
                }
                label={
                  <ListItemText
                    primary={column.label}
                    primaryTypographyProps={{
                      sx: { fontSize: "0.86rem", fontWeight: 600, color: mTokens.textPrimary },
                    }}
                  />
                }
              />
            </ListItem>
          );
        })}
      </List>
    </Box>
  );
};

export default ColumnToggle;
